import { TPurePdadType } from './PdadTypes'
import { TTransportOrCarriageMode } from './TransportMode'
import { EventCode } from './TransportPlanEvent'
import { TTransportType } from './TransportType'

type PdadEventMap = {
  lcl: {
    sea: EventCode
    air: EventCode
    rail?: EventCode
  }
  fcl: {
    sea: EventCode
    rail?: EventCode
  }
}

const pickupEventsMap: PdadEventMap = {
  lcl: {
    sea: EventCode.SPS,
    air: EventCode.SPS,
    rail: EventCode.RAIL_PICKUP,
  },
  fcl: {
    sea: EventCode.CAS,
    rail: EventCode.RAIL_PICKUP,
  },
}

const departureEventsMap: PdadEventMap = {
  lcl: {
    sea: EventCode.VDL,
    air: EventCode.ADO,
    rail: EventCode.RAIL_DEPARTURE,
  },
  fcl: {
    sea: EventCode.VDL,
    rail: EventCode.RAIL_DEPARTURE,
  },
}

const arrivalEventsMap: PdadEventMap = {
  lcl: {
    sea: EventCode.VAD,
    air: EventCode.AAD,
    rail: EventCode.RAIL_ARRIVAL,
  },
  fcl: {
    sea: EventCode.VAD,
    rail: EventCode.RAIL_ARRIVAL,
  },
}

const cgomoEventsMap: PdadEventMap = {
  lcl: {
    // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'EventCode'.
    sea: null,
    // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'EventCode'.
    air: null,
  },
  fcl: {
    sea: EventCode.CGOMO,
  },
}

const cgomdEventsMap: PdadEventMap = {
  lcl: {
    // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'EventCode'.
    sea: null,
    // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'EventCode'.
    air: null,
  },
  fcl: {
    sea: EventCode.CGOMD,
  },
}

const deliveryEventsMap: PdadEventMap = {
  lcl: {
    sea: EventCode.SDC,
    air: EventCode.SDC,
    rail: EventCode.RAIL_DELIVERY,
  },
  fcl: {
    sea: EventCode.CDC,
    rail: EventCode.RAIL_DELIVERY,
  },
}

const cargoReadyEventsMap: PdadEventMap = {
  lcl: {
    sea: EventCode.CRD,
    air: EventCode.CRD,
    rail: EventCode.RAIL_CARGO_READY,
  },
  fcl: {
    sea: EventCode.CRD,
    rail: EventCode.RAIL_CARGO_READY,
  },
}

const eventsMap: Record<TPurePdadType, PdadEventMap> = {
  cargoReady: cargoReadyEventsMap,
  pickup: pickupEventsMap,
  cgomo: cgomoEventsMap,
  departure: departureEventsMap,
  arrival: arrivalEventsMap,
  cgomd: cgomdEventsMap,
  delivery: deliveryEventsMap,
}

export const getPdadEventCode = (
  pdadType: TPurePdadType,
  transportType: TTransportType,
  transportMode: TTransportOrCarriageMode
) => {
  return eventsMap[pdadType][transportType][transportMode]
}
